const homeData = {
    brand: "JOEL MICHAEL",
    eyebrow: "LAUNCHING SOON",
    headlineLine1: "ESSENCE",
    headlineLine2: "OF SCENT.",
    tagline: "True luxury doesn't seek attention — it is the art of being felt, not seen.",
    taglineLine1: "True luxury doesn't seek attention — it is the art of",
    taglineLine2: "being felt, not seen.",
    joined: 1268,
    goal: 10000,
    stats: [
        { value: "1200+", label: "ON THE WAITLIST" },
        { value: "REMEMBRANCE", label: "FELT, NOT SEEN" },
        { value: "REFLECTION", label: "YOUR TRUE IDENTITY" },
        { value: "RESONANCE", label: "BREAKING LIMIT" },
    ],
    ctaLabel: "JOIN THE SOVEREIGN LIST",
    membershipLabel: "Join Membership — £15.99",
    membershipNote: "Lock in priority access.",
    heroImage: "/assets/landingPage.jpg",

    // Philosophy -----------------------------------------------------------
    philosophy: {
        eyebrow: "THE PHILOSOPHY",
        headlineLine1: "IN A NOISY WORLD,",
        headlineLine2: "WE CHOOSE SILENCE.",
        body:
            "Perfume has forgotten how to be intimate. We are returning it to the skin — to memory, to the quiet moments that need no announcement.",
        image: "/assets/joelMichaelFemaleScentImage.jpg",
        cards: [
            {
                title: "PRESENCE",
                body: "A scent that arrives before words and stays after silence.",
            },
            {
                title: "RESTRAINT",
                body: "We compose in whispers. Nothing added that isn't essential.",
            },
            {
                title: "PERMANENCE",
                body: "Made in small numbered batches, meant to be remembered.",
            },
        ],
    },

    // Protocol (problem / solution) ----------------------------------------
    protocol: {
        eyebrow: "THE DIFFERENCE",
        headline: "THE JOEL MICHAEL PROTOCOL",
        problemLabel: "THE STATUS QUO",
        solutionLabel: "OUR STANDARD",
        rows: [
            {
                problem:
                    "The Dilution Of Luxury — Global Ubiquity Has Stripped 'niche' Houses Of Their Soul, Making Rarity A Relic Of The Past.",
                solution:
                    "Absolute Scarcity — A Finite Lifetime Limit Of 2,000 Units Globally, Restoring The Sanctity Of The Signature Scent.",
            },
            {
                problem:
                    "Transient Performance — Premium-Priced Colognes That Vanish Into Obscurity Within Hours, Offering No Legacy.",
                solution:
                    "Olfactory Mastery — High-Performance Extraits (30%+) Engineered For 12+ Hours Of Sillage And Presence.",
            },
            {
                problem:
                    "The Impersonal Transaction — Broad Retail Creates A Cold Exchange, Lacking Emotional Depth And Community.",
                solution:
                    "The EOS Sovereign — A Private Member Model Providing Elite Community Ingress And Invite-Only Acquisition.",
            },
        ],
    },

    // Yours soon enough ----------------------------------------------------
    soonEnough: {
        eyebrow: "YOURS SOON ENOUGH",
        headline: "ONLY 2000 BOTTLES PER LIFETIME",
        images: [
            "/assets/soonEnough_1.jpg",
            "/assets/soonEnough_2.jpg",
            "/assets/soonEnough_3.jpg",
        ],
    },

    // Comparison / pricing -------------------------------------------------
    comparison: {
        eyebrow: "LIMITED EARLY ACCESS",
        headline: "SOVEREIGN LIST VS. THE EOS LEGACY",
        body:
            "Secure your position within the EOS Legacy. Apply for membership or join our priority Sovereign List to guarantee your allocation when the vault opens.",
        free: {
            label: "SOVEREIGN LIST",
            price: "£0.00",
            perks: [
                "Priority Launch Intelligence & Ingress Alerts",
                "Inaugural Acquisition Priority",
                "The EOS Journal: Curated Olfactory Insights",
            ],
        },
        paid: {
            label: "EOS MEMBERSHIP",
            price: "£15.99",
            badge: "ONLY 2000 SPOT",
            perks: [
                "Private Procurement Privileges",
                "Certificate of Provenance & Authenticity",
                "The Digital Insignia of the EOS",
                "Private Communiqué with Joel Michael Founder",
                "Premiere Allocation Access",
                "Guaranteed Legacy Rate Protection",
            ],
            ctaLabel: "COMING SOON",
        },
        footnote: "JOEL MICHAEL IS LAUNCHING SOON,",
        footnoteStrong: "STAY CONNECTED",
    },

    // Personal signatures (testimonials) -----------------------------------
    signatures: {
        eyebrow: "FRAGRANCE ENTHUSIASTS",
        headline: "PERSONAL SIGNATURES",
        items: [
            {
                quote:
                    "I genuinely love it. The scent is smooth, well-balanced, and feels more premium than I expected. What surprised me most was how long it lasted and how versatile and unique it is. I'd definitely consider purchasing it when it's released, and I'd have no hesitation recommending it to others. Amazing product.",
                author: "William O.",
            },
            {
                quote:
                    "I like the sample because it was different, first of all, and then it was not so harsh; the scent is attractive. What surprised me was that it stays on for a long time, over a day, even after you wash and all. Yes, I would definitely purchase it when it is released, and I see myself recommending it to others, too. Thank you.",
                author: "Favour E. E.",
            },
            {
                quote:
                    "I really liked it. It had a clean, sophisticated scent that felt premium without being overpowering. I was pleasantly surprised by how long it lasted on my skin. I'd definitely purchase it when it's released and would happily recommend it to others.",
                author: "Princella S.",
            },
            {
                quote:
                    "I like how distinct it is from other brands and how it endows exclusivity on whoever wears it. I was also surprised by how much variety was available; there was a scent for every situation. I would purchase the product when it is released and will definitely recommend it.",
                author: "Epiphany E.",
            },
            {
                quote:
                    "Joel Michael smells rich, refined, and well put together. First impression gave a luxury feel without being too strong or overwhelming. The projection was really good, and it lasted a long time. I would recommend it to others, anyone who appreciates premium fragrances and is looking for something that feels distinctive and high quality.",
                author: "Stephanie O.",
            },
            {
                quote:
                    "My expectations were not too high based on the fact that this was a new product. However, it exceeded my expectations, I wore it to work to try it out. After a whole day at work, I was surprised I could still smell the Scent on my clothing and Skin. I will definitely purchase it when it is released, and I will surely recommend it to my friends and colleagues.",
                author: "Jennifer J.",
            },
        ],
    },

    // Founder --------------------------------------------------------------
    founder: {
        eyebrow: "THE FOUNDER",
        headlineLine1: "THE ARCHITECT OF ESSENCE:",
        headlineLine2: "FROM DATA TO DREAMS",
        image: "/assets/ceoImage.png",
        pullQuote:
            "“I grew up in a small town, where luxury was something you dreamed of, not something you wore.”",
        paragraphs: [
            "As a young boy, I couldn't afford fine perfumes. But my mother's collection was my secret sanctuary. I remember tiptoe`ing into her room, lifting the heavy glass bottles, and breathing in a future I hadn't yet reached. To me, those scents weren't just liquids; they were messengers of identity",
            "I spent the next decade training my mind in the world of logic. I became a Software Engineer and later earned a distinction in Data Science from Nottingham Trent University. I learned to build systems, analyze markets, and find the “truth” hidden in data. But I realized something that data could never capture: the way a scent anchors a memory.",
            "Coming from a background of engineering and entrepreneurship, I saw a “glitch” in the system of luxury. True luxury shouldn't be everywhere. It should be a quiet signature. That is why I founded Joel Michael.",
            "At Joel Michael, we believe you already carry a scent — your courage, your kindness, your specific history. Our fragrances don't create your essence; they find you in it.",
            "With every bottle, you're not just wearing a fragrance. You are holding a piece of a 2,000 unit legacy.",
        ],
        signature: "— JOEL MICHAEL, FOUNDER",
    },

    // Frequent inquiries ---------------------------------------------------
    faq: {
        headline: "FREQUENT INQUIRIES",
        items: [
            {
                q: "WHY THE FINITE LIMIT OF 2,000 UNITS PER SIGNATURE?",
                a: "To preserve the absolute sanctity of your scent. We view fragrance as liquid real estate; once the 2,000th allocation is secured, the formulation is vaulted eternally to protect its rarity and ensure it never becomes a commodity.",
            },
            {
                q: "IS EOS MEMBERSHIP MANDATORY FOR ACQUISITION?",
                a: "Yes. To maintain the integrity of our scarcity model, ingress is restricted to our private registry. Membership grants you procurement rights, premiere allocations, and private access to founder-led olfactory events.",
            },
            {
                q: "WHAT DISTINGUISHES A JOEL MICHAEL EXTRAIT FROM RETAIL OFFERINGS?",
                a: "Concentration and traceability. While corporate “niche” brands dilute to 15%, we engineer Extraits at 30%–35% using rare micro-lot naturals. This ensures a 12-hour sillage and a complex, morphing signature that retail colognes cannot replicate.",
            },
            {
                q: "ARE JOEL MICHAEL SIGNATURES AVAILABLE AT LUXURY DEPARTMENT CONCESSIONS?",
                a: "No. We operate on a strict anti-retail doctrine. True luxury is not a convenience found in a crowded store. By bypassing traditional retail, we deliver our vaulted signatures directly from the lab to your private collection, reinvesting retail markups into ingredient quality.",
            },
            {
                q: "DOES THE LIMITED ALLOCATION IMPLY POTENTIAL ASSET APPRECIATION?",
                a: "By design, yes. The mathematics of our 2,000-unit cap creates a natural secondary market. As global supply diminishes, the provenance of a certified, sealed Joel Michael signature mirrors that of a rare timepiece or fine vintage asset.",
            },
        ],
    },

    // Footer ---------------------------------------------------------------
    footer: {
        brand: "JOEL MICHAEL",
        socialHandle: "JOELMICHAELLUX",
        copyright: "© 2026 JOEL MICHAEL. ESSENCE OF SCENT",
        socials: [
            {
                name: "Instagram",
                icon: "/assets/instagram.svg",
                url: "https://instagram.com/joelmichaellux",
            },
            {
                name: "X",
                icon: "/assets/twitter.svg",
                url: "https://x.com/joelmichaellux",
            },
            {
                name: "YouTube",
                icon: "/assets/youtube.svg",
                url: "https://www.youtube.com/@JoelMichaelLux",
            },
            {
                name: "TikTok",
                icon: "/assets/tiktok.svg",
                url: "https://www.tiktok.com/@joelmichaellux",
            },
            {
                name: "LinkedIn",
                icon: "/assets/linkedin.svg",
                url: "https://linkedin.com/company/joelmichaellux",
            },
        ],
    },
    copyrRightMessage: "Copyright © 2025 Joel Michael. House of Essence.",
    // Success dialog (reused by SuccessDialog.js)
    successTitleImage: "/assets/Checkmark.png",
    dialogSuccessMessage: "Successfully added to our waitlist.",
    dialogSuccessMessage2: "Get ready for our launch",
    dialogSuccessSecondaryMessage: "Don't forget to follow our social accounts below",
};

export default homeData;
